import { render, staticRenderFns } from "./GameGroupForm.vue?vue&type=template&id=1bf3be0c"
import script from "./GameGroupForm.vue?vue&type=script&lang=js"
export * from "./GameGroupForm.vue?vue&type=script&lang=js"
import style0 from "./GameGroupForm.vue?vue&type=style&index=0&id=1bf3be0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports